CustomTC.define('jquery/data/var/data_priv',[
	"../Data"
], function( Data ) {
	return new Data();
});

